export default __webpack_public_path__ + "static/media/about-svg.22487d7a.svg";